import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./ready.css";

export default function Ready() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/quiz", {
        state: {
          answerData: "tutorialQuiz1",
          DateVal: "tutorialQuiz1",
          titImgClass: "tutorialQuiz1Tit",
        },
      });
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="content" className="readyPop">
      <div
        className="boxPop content_box1"
        style={{ animation: "fadeOut 5s 1s forwards" }}
      >
        <div className="con_box_ready">
          <div className="ready_icon"></div>
          <p className="ready_tit">MISSION</p>
          <p className="ready_expl mt16">
            사라진 황금 안장을 되찾고
            <br />
            정예요원이 되세요!
          </p>
          <p className="ready_txt mt16">~ 미션 준비 중 ~</p>
        </div>
      </div>
    </div>
  );
}
